module.exports = __webpack_public_path__ + "media/icons/web-9800ef70.png";